<div class="page-500-error">
  <div class="ico-content">
    <i class="branch-ico"></i>
  </div>
  <div class="title-content">
    <h1 class="title">Something</h1>
    <h1 class="title">is off…</h1>
  </div>
  <div class="details-content">
    <h1 class="title">In the mean time, we can go back try</h1>
    <h1 class="title">another action</h1>
  </div>
  <div class="btn-back" [routerLink]="['/dashboard']">
    <span>Back to my Home Screen</span>
  </div>
  <div class="contact-support">
    <span>If this happens again, please </span>
    <span class="link" (click)="goToUrl('https://help.cropx.com/')"
      >Contact Support
    </span>
    <span>or try </span>
    <span class="link" (click)="onLogout()">Log Out</span>
  </div>
</div>
